module.exports = __webpack_public_path__ + "static/media/google-play-badge-de.ac138446.png";